import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export interface SystemErrorModalState {
  open: boolean;
  title: string;
  body: string;
  confirmLabel: string;
}

const DEFAULT_STATE: SystemErrorModalState = {
  open: false,
  title: '¡Algo salió mal!',
  body: 'Hubo un problema con el sistema. Por favor inténtalo de nuevo en unos minutos.',
  confirmLabel: 'Entendido',
};

@Injectable({ providedIn: 'root' })
export class SystemErrorModalService {
  private readonly stateSubject = new BehaviorSubject<SystemErrorModalState>(DEFAULT_STATE);

  readonly state$: Observable<SystemErrorModalState> = this.stateSubject.asObservable();

  show(patch?: Partial<Omit<SystemErrorModalState, 'open'>>): void {
    const current = this.stateSubject.getValue();
    this.stateSubject.next({
      ...current,
      ...patch,
      open: true,
    });
  }

  close(): void {
    const current = this.stateSubject.getValue();
    if (!current.open) return;
    this.stateSubject.next({
      ...current,
      open: false,
    });
  }
}

